var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#3D9F4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 56.6666V38.3333M23.3334 41.6666V53.3333C23.3334 55.1743 24.8258 56.6666 26.6667 56.6666H49.0438C51.5116 56.6666 53.6104 54.8661 53.9856 52.4269L55.7805 40.7603C56.2465 37.7315 53.9031 35 50.8387 35H45C44.0796 35 43.3334 34.2538 43.3334 33.3333V27.443C43.3334 25.1733 41.4934 23.3333 39.2236 23.3333C38.6823 23.3333 38.1917 23.6521 37.9718 24.1469L32.1066 37.3435C31.8391 37.9454 31.2422 38.3333 30.5836 38.3333H26.6667C24.8258 38.3333 23.3334 39.8257 23.3334 41.6666Z",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.ecef83dde4af281522b5a43108b72701.svg";
export { ForwardRef as ReactComponent };